import { IModel } from '@/@types/models/model';
import { coreFields } from '@/models/helpers/coreFields';
import { commonFields } from './helpers/commonFields';
import { routingFields } from './helpers/routingFields';

const Izlet: IModel = {
  title: 'Izlet',
  apiPath: 'hps/izleti',
  httpUpdateVerb: 'put',
  forms: {
    default: {
      fields: ['id'],
    },
    korisnik: {
      fields: [{ source: 'odrediste', width: 'full' }, 'prvi_dan', 'trajanje_dani', 'interna_napomena'],
    },
    reg: {
      fields: [{ source: 'odrediste', width: 'full' }, 'prvi_dan', 'trajanje_dani', 'interna_napomena'],
    },
    vodic: {
      fields: ['odrediste', 'drzava_id', 'prvi_dan', 'trajanje_dani', 'organizator_udruga_id', 'broj_sudionika', 'interna_napomena'],
    },
    udruga: {
      fields: ['odrediste', 'drzava_id', 'prvi_dan', 'trajanje_dani', 'organizator_udruga_id', 'broj_sudionika', 'interna_napomena'],
    },
    spv: {
      fields: ['odrediste', 'drzava_id', 'prvi_dan', 'trajanje_dani', 'organizator_udruga_id', 'broj_sudionika', 'interna_napomena'],
    },
    komisija: {
      fields: ['odrediste', 'drzava_id', 'prvi_dan', 'trajanje_dani', 'organizator_udruga_id', 'broj_sudionika', 'interna_napomena'],
    },
  },
  listViews: {
    default: {
      fields: ['id'],
    },
    korisnik: {
      fields: ['id', 'odrediste', 'prvi_dan', 'trajanje_dani', 'interna_napomena', 'created_on', 'total_length', 'total_time_min', 'total_ascent', 'total_descent'],
      hidden: ['id'],
    },
    reg: {
      fields: [
        'id',
        'odrediste',
        'prvi_dan',
        'trajanje_dani',
        'created_on',
        'total_length',
        'total_time_min',
        'total_ascent',
        'total_descent'
      ],
      hidden: ['id'],
    },
    vodic: {
      fields: [
        'id',
        'active',
        'odrediste',
        'drzava_id',
        'prvi_dan',
        'trajanje_dani',
        'max_standard_id',
        'organizator_udruga_id',
        'vodici_count',
        'sudionici_count',
        'interna_napomena',
        'is_otkazan',
        'status_id',
        'is_javno',
        'is_odrzan',
        'created_on',
        'created_by',
        'uloga'
      ],
      hidden: ['id', 'active'],
    },
    udruga: {
      fields: [
        'id',
        'active',
        'odrediste',
        'drzava_id',
        'prvi_dan',
        'trajanje_dani',
        'organizator_udruga_id',
        'vodici_count',
        'sudionici_count',
        'is_otkazan',
        'status_id',
        'is_javno',
        'is_odrzan',
        'created_on',
      ],
      hidden: ['id', 'active'],
    },
    spv: {
      fields: [
        'id',
        'active',
        'odrediste',
        'drzava_id',
        'prvi_dan',
        'trajanje_dani',
        'organizator_udruga_id',
        'vodici_count',
        'sudionici_count',
        'is_otkazan',
        'status_id',
        'is_javno',
        'is_odrzan',
        'created_on',
      ],
      hidden: ['id', 'active'],
    },
    komisija: {
      fields: [
        'id',
        'active',
        'odrediste',
        'drzava_id',
        'prvi_dan',
        'trajanje_dani',
        'organizator_udruga_id',
        'vodici_count',
        'sudionici_count',
        'is_otkazan',
        'status_id',
        'is_javno',
        'is_odrzan',
        'created_on',
      ],
      hidden: ['id', 'active'],
    },
    vodic_izleti: {
      fields: [
        'id',
        'active',
        'uloga',
        'odrediste',
        'drzava_id',
        'prvi_dan',
        'trajanje_dani',
        'max_standard_id',
        'organizator_udruga_id',
        'interna_napomena',
        'is_otkazan',
        'status_id',
        'is_odrzan',
        'created_on',
      ],
      hidden: ['id', 'drzava_id', 'interna_napomena', 'is_otkazan', 'active'],
    },
  },
  fields: [
    coreFields.id,
    commonFields.wkt,
    commonFields.proj,
    {
      title: 'Organizator udruga',
      source: 'organizator_udruga_id',
      ttoken: 'hps.izleti.organizator_udruga',
      type: 'picker',
      subModel: {
        apiPath: 'hps/planinarske-udruge?need_for=picker',
        format: '{label}',
      },
      validation: {
        required: true,
      },
    },
    {
      title: 'Država',
      source: 'drzava_id',
      ttoken: 'common.drzava',
      type: 'picker',
      subModel: {
        apiPath: 'hps/izlet-drzave',
        format: '{label}',
      },
      validation: {
        required: true,
      },
      translate: true,
    },
    {
      title: 'Odredište',
      source: 'odrediste',
      ttoken: 'hps.izlet.odrediste',
      type: 'text',
      validation: {
        required: true,
        maxLength: 100
      },
    },
    {
      title: 'Prvi dan',
      source: 'prvi_dan',
      ttoken: 'hps.izleti.prvi_dan',
      type: 'date',
      validation: {
        required: true,
      },
      tooltip: "hps.izleti.prvi_dan_tooltip"
    },
    {
      title: 'Trajanje dani',
      source: 'trajanje_dani',
      ttoken: 'hps.izleti.trajanje_dani',
      type: 'wholenum',
      validation: {
        required: true,
      },
    },
    {
      title: 'Broj sudionika',
      source: 'broj_sudionika',
      ttoken: 'hps.izleti.broj_sudionika',
      type: 'wholenum',
      validation: {
        required: true,
      },
    },
    {
      title: 'Je li javno',
      source: 'is_javno',
      ttoken: 'common.public',
      type: 'boolean',
      items: {
        labels: ['common.ne', 'common.da'],
        values: [false, true],
        icons: ['public_off', 'public'],
        iconColors: ['#fc9272','#1a9850'],
        default: true,
      },
      validation: {
        required: true,
      },
      default: true,
      translate: true,
    },
    {
      title: 'Ulazi u statistiku',
      source: 'is_stats',
      ttoken: 'hps.izleti.is_stats',
      type: 'boolean',
      items: {
        labels: ['common.ne', 'common.da'],
        values: [false, true],
        default: true,
      },
      validation: {
        required: true,
      },
      default: true,
      translate: true,
    },
    {
      title: 'Interna napomena',
      source: 'interna_napomena',
      ttoken: 'hps.plan_udruge.inerna_napomena',
      type: 'text',
      width: 'full',
      validtion: {
        maxLength: 1000
      }
    },
    {
      title: 'Je li otkazan',
      source: 'is_otkazan',
      ttoken: 'hps.izleti.is_otkazan',
      type: 'boolean',
      items: {
        labels: ['common.ne', 'common.da'],
        values: [false, true],
        icons: ['','cancel'],
        iconColors: ['','#fc9272'],
        default: false,
      },
      default: false,
      translate: true,
    },
    {
      title: 'Je li održan',
      source: 'is_odrzan',
      ttoken: 'hps.izleti.is_odrzan',
      type: 'boolean',
      items: {
        labels: ['common.ne', 'common.da'],
        values: [false, true],
        icons: ['question_mark', 'done_all'],
        iconColors: ['#3288bd', '#1a9850']
      },
      default: false,
      translate: true,
    },
    {
      title: 'Max Standard',
      source: 'max_standard_id',
      ttoken: 'hps.izleti.standard',
      type: 'picker',
      items: {
        labels: [
          'hps.vodicki_standardi.a',
          'hps.vodicki_standardi.b',
          'hps.vodicki_standardi.c',
          'hps.vodicki_standardi.d',
          'hps.vodicki_standardi.e',
          'hps.vodicki_standardi.f',
          'hps.vodicki_standardi.g',
        ],
        values: [10, 20, 30, 40, 50, 60, 70],
      },
      readonly: true,
      translate: true,
    },
    {
      title: 'Uloga',
      source: 'uloga',
      ttoken: 'hps.izleti.uloga',
      type: 'picker',
      items: {
        labels: ['hps.izlet-uloge.vodic', 'hps.izlet-uloge.sudionik'],
        values: [10, 20],
      },
      readonly: true,
      translate: true,
    },
    {
      title: 'Status',
      source: 'status_id',
      ttoken: 'hps.izleti.status',
      type: 'picker',
      items: {
        labels: ['hps.izlet_statusi.draft', 'hps.izlet_statusi.submitted', 'hps.izlet_statusi.approved'],
        values: [10, 20, 30],
        icons: ['mode_edit', 'cloud', 'done'],
        iconColors: ['#fee08b', '#3288bd', '#1a9850']
      },
      readonly: true,
      translate: true,
    },
    {
      title: 'can_edit',
      source: 'can_edit',
      ttoken: 'common.can_edit',
      type: 'boolean',
      readonly: true,
    },
    {
      title: 'Vodici Count',
      source: 'vodici_count',
      ttoken: 'hps.izleti.vodici_count',
      type: 'wholenum',
      readonly: true,
      calculated: true
    },
    {
      title: 'Sudionici Count',
      source: 'sudionici_count',
      ttoken: 'hps.izleti.sudionici_count',
      type: 'wholenum',
      readonly: true,
      calculated: true
    },
    coreFields.active,
    coreFields.created_by,
    coreFields.created_on,
    coreFields.modified_by,
    coreFields.modified_on,
    {
      title: 'Naziv udruge',
      source: 'organizator_udruga_naziv',
      ttoken: 'common.naziv',
      type: 'text',
      readonly: true
    },
    routingFields.total_length,
    routingFields.total_time_min,
    routingFields.total_ascent,
    routingFields.total_descent
  ],
};

export default Izlet;
